import { useTranslation } from 'react-i18next';
import Highlight from '../../../components/Highlight';

export default function Hero() {
  const { t } = useTranslation();
  return (
    <section className="bg-surface">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-24 text-center">
        <h1 className="text-[34px] font-bold leading-[1.15] tracking-tight md:text-[52px]">
          <Highlight text={t('main.hero.title')} />
        </h1>
        <p className="mt-5 mx-auto max-w-2xl text-[16px] md:text-[18px] leading-[1.6] text-ink-soft">
          {t('main.hero.subtitle')}
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <a
            href="/#countries"
            className="inline-flex items-center justify-center rounded-md bg-primary px-7 py-3.5 text-[15px] font-semibold text-white transition hover:bg-primary-hover cursor-pointer whitespace-nowrap"
          >
            {t('main.hero.cta')}
          </a>
          <a
            href="/how-it-works"
            className="inline-flex items-center justify-center rounded-md border border-border bg-white px-7 py-3.5 text-[15px] font-medium text-ink transition hover:border-primary cursor-pointer whitespace-nowrap"
          >
            {t('main.hero.howItWorks')}
          </a>
        </div>
        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2 text-[13px] text-muted">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-check-line w-4 h-4 flex items-center justify-center text-primary" />
            {t('main.features.checkout')}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-check-line w-4 h-4 flex items-center justify-center text-primary" />
            {t('main.features.email')}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-check-line w-4 h-4 flex items-center justify-center text-primary" />
            {t('main.features.payment')}
          </span>
        </div>
      </div>
    </section>
  );
}
